/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Open_SettingsInputs */

const vi_irrigation_devices_open_settings = /** @type {(inputs: Irrigation_Devices_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở cấu hình SmartLab`)
};

/**

* @param {Irrigation_Devices_Open_SettingsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_open_settings = /** @type {((inputs?: Irrigation_Devices_Open_SettingsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Open_SettingsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_open_settings(inputs)
});